import { ReactComponent as BorderPicker } from 'assets/icons/borderWidth.svg';
import { ReactComponent as ChevronPicker } from 'assets/icons/chevron4.svg';

import style from '../SelectedItemMenu.module.css';

const SetBorder = ({ value, onChange }) => {
  const increaseItem = () => {
    onChange({ changed: 'strokeWidth', value: value + 1 });
  };
  const deincreaseItem = () => {
    if (value - 1 < 0) return;
    onChange({ changed: 'strokeWidth', value: value - 1 });
  };
  return (
    <div className={style.inputContainer}>
      <BorderPicker />
      <input
        className={style.numberSelect}
        onChange={e => {
          if (Number(e.currentTarget.value) < 0) return;
          onChange({ changed: 'strokeWidth', value: e.currentTarget.value });
        }}
        value={value}
        type="number"
      />
      <div className={style.numberControlls}>
        <span onClick={increaseItem}>
          <ChevronPicker />
        </span>
        <span onClick={deincreaseItem}>
          <ChevronPicker />
        </span>
      </div>
    </div>
  );
};

export default SetBorder;
